import { Component, computed, inject } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { Permiso } from '../auth/permisos';
import { PermissionsService } from '../services/permissions.service';
import { iniciales, nombreUsuario, rolUsuario } from './usuario-display';
import { LayoutService } from '../services/layout.service';
import { ThemeService } from '../services/theme.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.html',
})
export class Topbar {
  protected readonly theme = inject(ThemeService);
  protected readonly layout = inject(LayoutService);
  private readonly auth = inject(AuthService);
  private readonly permisos = inject(PermissionsService);

  protected readonly nombre = computed(() => nombreUsuario(this.auth.usuario()));
  protected readonly iniciales = computed(() => iniciales(this.auth.usuario()));
  protected readonly rol = computed(() => rolUsuario(this.auth.usuario()));
  protected readonly regional = computed(() => this.auth.usuario()?.regional ?? null);
  /** Con este permiso las listas no se filtran por la regional. */
  protected readonly veTodas = computed(() => this.permisos.can(Permiso.REGIONALES_TODAS));

  cerrarSesion(): void {
    this.auth.logout();
  }
}
